<template>
  <!-- 个人中心 -->
  <div class="personal no-image">
    <infoBackground></infoBackground>
    <div class="person-head">
      <div class="personal">
        <div class="avatar" v-if="userInfo">
          <i class="avatar-icon" :style="{ backgroundImage: 'url(' + userInfo.HeadPhotoPath + ')' }"></i>
          <p>{{ userInfo.NickName }}</p>
  
        </div>
      </div>
      <div class="person-menu">
        <div class="menu">
          <span :class="{ selected: currentType == item.type }" v-for="item in menuList"
            @click="currentType = item.type">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="person-content" v-if="userInfo">
      <userInfo @refreshVIP="refreshVIP()" v-if="currentType == 'user-info'"></userInfo>
      <buyOrder v-if="currentType == 'buy-order'"></buyOrder>
      <portraitsInfo v-if="currentType == 'portraits-info'"></portraitsInfo>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import * as moment from "moment";

import foot from "@/component/public/foot/foot.vue";
import navroot from "@/component/public/nav/nav.vue";
import infoBackground from "@/component/public/info-background/info-background.vue";

import userInfo from "@/component/personal/user-info/user-info.vue";
import buyOrder from "@/component/personal/buy-order/buy-order.vue";
import portraitsInfo from '@/component/personal/portraits-info/portraits-info.vue';

import { VIP_PLATFORM } from '@/config/constant'

export default {
  components: {
    foot,
    navroot,
    infoBackground,
    userInfo,
    buyOrder,
    portraitsInfo
  },
  data() {
    return {
      userInfo: null,
      menuList: [
        { name: '个人信息', type: 'user-info' },
        { name: '已购订单', type: 'buy-order' },
        { name: '阅读数据', type: 'portraits-info' }
      ],
      currentType: "user-info",
    }
  },
  async mounted() {
    let { userInfo, studentVip } = this.$store.state;
    if (!userInfo) {
      return this.$router.push('/login');
    }

    this.userInfo = userInfo;
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "./personal.scss";
</style>